import { render, staticRenderFns } from "./SlideBookmarksPane.vue?vue&type=template&id=0b219acc&scoped=true"
import script from "./SlideBookmarksPane.vue?vue&type=script&lang=ts"
export * from "./SlideBookmarksPane.vue?vue&type=script&lang=ts"
import style0 from "./SlideBookmarksPane.vue?vue&type=style&index=0&id=0b219acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b219acc",
  null
  
)

export default component.exports